import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
var AppModule = (function () {
    function AppModule() {
    }
    return AppModule;
}());
export { AppModule };
export function HttpLoaderFactory(http) {
    return new TranslateHttpLoader(http);
}



// WEBPACK FOOTER //
// /opt/app/src/app/app.module.ts.pre-build-optimizer.js